import React, { useState, useEffect } from 'react';
import { Save } from 'lucide-react';
import ImageUpload from '../../components/admin/ImageUpload';

const AuthorsManager = () => {
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAuthors();
  }, []);

  const fetchAuthors = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/authors`);
      const data = await response.json();
      if (data.success) setAuthors(data.authors);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (author) => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/authors/${author.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(author)
      });
      const data = await response.json();
      if (response.ok && data.success) {
        alert('Author updated successfully!');
      } else {
        alert(data.detail || 'Failed to update author');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to update author');
    } finally {
      setLoading(false);
    }
  };

  const updateAuthor = (id, field, value) => {
    setAuthors(authors.map(a => a.id === id ? { ...a, [field]: value } : a));
  };

  return (
    <div>
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: '700', marginBottom: '24px' }}>
        Authors Manager
      </h1>

      {loading ? (
        <div style={{ textAlign: 'center', color: '#666666', padding: '32px' }}>Loading...</div>
      ) : (
        <div style={{ display: 'grid', gap: '24px' }}>
          {authors.map((author) => (
            <div key={author.id} style={{ backgroundColor: '#FFFFFF', padding: '32px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '24px' }}>{author.name}</h2>
              <div style={{ display: 'grid', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: '600', marginBottom: '8px' }}>Short Bio</label>
                  <textarea value={author.short_bio} onChange={(e) => updateAuthor(author.id, 'short_bio', e.target.value)} rows="3" style={{ width: '100%', padding: '10px 14px', border: '1px solid #E0E0E0', borderRadius: '4px', fontFamily: 'var(--font-body)', resize: 'vertical' }} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: '600', marginBottom: '8px' }}>Full Bio</label>
                  <textarea value={author.full_bio} onChange={(e) => updateAuthor(author.id, 'full_bio', e.target.value)} rows="6" style={{ width: '100%', padding: '10px 14px', border: '1px solid #E0E0E0', borderRadius: '4px', fontFamily: 'var(--font-body)', resize: 'vertical' }} />
                </div>
                <div>
                  <ImageUpload
                    label="Author Photo"
                    value={author.photo_url}
                    onChange={(url) => updateAuthor(author.id, 'photo_url', url)}
                    testid={`author-photo-${author.id}`}
                  />
                </div>
                <button onClick={() => handleUpdate(author)} disabled={loading} className="btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '8px', width: 'fit-content' }}>
                  <Save size={18} /> {loading ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AuthorsManager;
